import { BATTERY_IMEI_LENGTH } from "./emiConfig";
import FinancierSelectionStep from "../steps/FinancierSelectionStep";
import DriverInformationStep from "../steps/DriverInformationStep";
import AssetAllocationStep from "../steps/AssetAllocationStep";
import DocumentUploadStep from "../steps/DocumentUploadStep";
import { ROLES } from "../../../constants/roles";

export const validateDriverInformation = (data) => {
  const requiredFields = [
    "driverName",
    "phoneNumber",
    "age",
    "city",
    "invoiceValue",
    "downpayment",
    "emiTenure",
    "vehicleFinanced",
  ];

  const baseValid = requiredFields.every(
    (field) => String(data[field] || "").trim() !== "",
  );

  const financierValid =
    data.vehicleFinanced !== "Yes" ||
    (String(data.vehicleFinancierDetails?.name || "").trim() !== "" &&
      String(data.vehicleFinancierDetails?.phoneNumber || "").trim() !== "" &&
      String(data.vehicleFinancierDetails?.address || "").trim() !== "");

  return baseValid && financierValid;
};

export const validateAssetAllocation = (data) =>
  String(data.batteryType || "").trim() !== "" &&
  String(data.batteryImei || "").trim() !== "" &&
  String(data.chargerId || "").trim() !== "";

export const validateDocumentUploadForDealer = (data) =>
  Boolean(data.aadhaarFrontUrl) &&
  Boolean(data.aadhaarBackUrl) &&
  Boolean(data.panCardUrl) &&
  Boolean(data.rcFrontUrl) &&
  Boolean(data.rcBackUrl) &&
  Boolean(data.addressProofUrl);

export const validateDocumentUploadForAdmin = (data) =>
  validateDocumentUploadForDealer(data) && Boolean(data.crifReportUrl);

export const validateFinancierSelection = (data) =>
  Boolean(data.selectedFinancier);

export const validateDocumentUploadByRole = (data, role) =>
  role === ROLES.ADMIN
    ? validateDocumentUploadForAdmin(data)
    : validateDocumentUploadForDealer(data);

export const STEPS = [
  {
    key: "driverInformation",
    label: "Driver Information",
    Component: DriverInformationStep,
    validate: validateDriverInformation,
    initialData: {
      driverName: "",
      phoneNumber: "",
      age: "",
      city: "",
      invoiceValue: "",
      downpayment: "",
      emiTenure: "",
      vehicleFinanced: "",
      vehicleFinancierDetails: {
        name: "",
        phoneNumber: "",
        address: "",
      },
    },
  },
  {
    key: "assetAllocation",
    label: "Asset Allocation",
    Component: AssetAllocationStep,
    validate: validateAssetAllocation,
    initialData: {
      batteryType: "",
      batteryImei: "",
      chargerId: "",
    },
  },
  {
    key: "documentUpload",
    label: "Document Upload",
    Component: DocumentUploadStep,
    initialData: {
      aadhaarFrontUrl: null,
      aadhaarBackUrl: null,
      panCardUrl: null,
      addressProofUrl: null,
      rcFrontUrl: null,
      rcBackUrl: null,
      crifReportUrl: null,
    },
  },
  {
    key: "financierSelection",
    label: "Financier Selection",
    Component: FinancierSelectionStep,
    validate: validateFinancierSelection,
    initialData: {
      selectedFinancier: "",
    },
  },
];
